// extracted by mini-css-extract-plugin
module.exports = {"messageHistory":"ChatMessageContent_messageHistory__yZ8vC"};